<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Funnies</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createFunny">Create Funny</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="funnies.columns" :data="funnies.data">
                    <template slot="table-row" v-if="funnies.data.length">
                        <tr v-for="(item, index) in funnies.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.funnyName}}</td>
                            <td><a :href="item.funnyUrl" target="_blank">{{item.funnyUrl}}</a></td>
                            <td ><img class="table-thumbnail" :title="item.funnyUrl":src="item.funnyUrl" /></td>
                             <td>{{item.csvCorporationName}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewFunny(item)" v-tooltip.top-center="funnies.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editFunny(item)" v-tooltip.top-center="funnies.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const funniesColumns = ['Funny Title', 'URL','Image', 'Corporations', 'Status', 'Operations'];
    export default {
        name: 'Funnies',
        components: {
            LTable,
        },
        data() {
        return {
              funnies: {
                tooltips: {
                    view: 'View Funny',
                    edit: 'Edit Funny',
                    delete: 'Inactivate Funny',
                    activate:'Activate Funny',
                },
                columns: [...funniesColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        fetchFunnies () {
            this.$store.dispatch('FETCH_FUNNIES')
                    .then((res) => {
                        this.funnies.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewFunny(funny){
            this.$router.push({ name: 'ViewFunny', params: { id: funny.funnyId}})
        },
        editFunny(funny){
            this.$router.push({ name: 'EditFunny', params: { id: funny.funnyId}})
        },
        createFunny(){
            this.$router.push({ name: 'CreateFunny'})
        }
    },
    created() {
        this.fetchFunnies();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Funnies/Funnies.vue